import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'findObj'
})
export class FindObjPipe implements PipeTransform {

  transform(list: any, key: string, value: any): any {
    if (!list || !key || !value) {
      return list;
    }
    return list.find(obj => obj[key] === value);
  }

}



// WEBPACK FOOTER //
// G:/UTL/Student/Student-ANG/src/app/shared/pipes/find-obj.pipe.ts